import React, { useState } from "react";
import { Card, Col, Row } from "reactstrap";
import FinallyChart from "./finallyAMChart";
// import FinallyChart2 from "./finallyHighChart";
// import AnalysisCard from "../Pages/Analysis/AnalysisCard";
import GroupWidget from "./GroupWidget";
import SmallWidget from "./SmallWidget";
import ChartWidget from "./ChartWidget";
import PlantStatus from "./PlantStatus";
import FatoryDetail from "./factoryDetails";
import Loader from "../../Loader";
import { gql, useQuery } from "@apollo/client";
import findPlantId from "../../Controllers/findPlantId";
import { Skeleton } from "antd";
import SolarPanelHeatmap from "./SolarPanelsHeatmap";

const DASHBOARD_INFO = gql`
  query ($plant_id: Int!) {
    GetPlantInfo(plant_id: $plant_id) {
      fact_address
      fact_index
      fact_name
      fact_power_name
      fact_power_unit
      fact_city

      incomeCardChartData {
        datasets
        title_value
      }
      productionCardChartData {
        title_value
        datasets
      }
      group_widget {
        all_income
        all_production
        gas_emission
        average_production
      }
      small_widget {
        totalPlantProductions
        RemainingBatteryCharging
        prod_index
        plantTempereture
      }
    }
  }
`;

const Dashboard = () => {
  const dashboardID = findPlantId();
  // console.log(dashboardID , "is dashboardID")
  // console.log(parseInt(dashboardID), "is plant id");

  const { data: GetPlantInfo, loading } = useQuery(DASHBOARD_INFO, {
    variables: { plant_id: parseInt(dashboardID) },
    onError: (err) => {
      console.log(err);
    },
  });

  const [BatteryPower, setBatteryPower] = useState(0);
  const [temp, setTemp] = useState(0);
  const [totalPlantProductions, setTotalPlantProductions] = useState(0);
  const [totalYearlyProduction, setTotalYearlyProduction] = useState(0);
  const [maximumDataProd, setMaximumDataProd] = useState(0);

  // console.log(status, "is status", isLoading, loader);
  // console.log("is dashboard props", props);

  if (!loading && GetPlantInfo) {
    const {
      fact_name,
      fact_address,
      fact_power_name,
      fact_power_unit,
      fact_index,
      fact_city,
      incomeCardChartData,
      productionCardChartData,
      group_widget,
      small_widget,
    } = GetPlantInfo?.GetPlantInfo;

    return (
      <div className="animated fadeIn">
        <Row className="">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <FatoryDetail
              fact_name={fact_name}
              fact_address={fact_address}
              fact_power_name={fact_power_name}
              fact_power_unit={fact_power_unit}
              fact_city={fact_city}
              setTemp={(temp) => setTemp(temp)}
            />
          </Col>
        </Row>
        <Row className="">
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className="mb-3">

            <PlantStatus
              plant_id={dashboardID}
              fact_power_name={fact_power_name}
              fact_power_unit={fact_power_unit}
            // setBatteryPower={(value) => setBatteryPower(value)}
            />

          </Col>
          <Col xs={12} sm={8} md={9} lg={9} xl={9} className="mb-3">
            <Card className="border-radius-15 p-3 h-100">
              <FinallyChart
                plant_id={dashboardID}
                totalPlantProductions={(energy) =>
                  setTotalPlantProductions(energy)
                }
                setTotalYearlyProduction={(energy) =>
                  setTotalYearlyProduction(energy)
                }
                MaximumDataProd={(energy) => setMaximumDataProd(energy)}
                setBatteryPower={(value) => setBatteryPower(value)}
              />
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12} className="mb-3">
            <SolarPanelHeatmap plantId={dashboardID} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <SmallWidget
              prod_index={small_widget.prod_index}
              plantTempereture={temp}
              totalPlantProductions={totalPlantProductions}
              BatteryPower={BatteryPower}
              data={group_widget}
              MaximumDataProd={maximumDataProd}
              totalYearlyProduction={totalYearlyProduction}
            />
          </Col>
        </Row>

        {/* <GroupWidget
          totalPlantProductions={totalPlantProductions}
          data={group_widget}
          MaximumDataProd={maximumDataProd}
          totalYearlyProduction={totalYearlyProduction}
        /> */}

        {
          // <Row>
          //   <Col>
          //     <Card className="p-4">
          //       <div className="h4 mb-2">رویداد های اخیر</div>
          //       <CardBody>
          //         <AlertTable data={resultData.alert_table} />
          //       </CardBody>
          //     </Card>
          //   </Col>
          // </Row>
          // <AnalysisCard />
          //   <Row>
          //   <Col xs="12" sm="12" lg="12">
          //     <Card>
          //       <FinallyChart2 />
          //     </Card>
          //   </Col>
          // </Row>
          // <InstallButton />
          // <Button
          //   onClick={() => {
          //     console.log(data, "is getting data 2");
          //   }}
          // >
          //   Fetching data
          // </Button>
        }
      </div>
    );
  } else {
    return (
      <div className="animated fadeIn ">
        <Loader />
      </div>
    );
  }
};

export default React.memo(Dashboard);
